var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen-background",style:({backgroundImage: ("url(" + (_vm.requireFromAssetsIfLocalSrc(_vm.backgroundImageURL)) + ")")})})}
var staticRenderFns = []

export { render, staticRenderFns }